export const firebaseConfig = {
  apiKey: 'AIzaSyDNEqebLcO8S50p6jzhcJCUPgSROvEussk',
  projectId: 'mike-eric',
};
